<template>
  <header>
    <div class="content">
      <div class="logo">
        <router-link to="/">
          <img src="../assets/img/ATG-Logo-large.png"/>
        </router-link>
      </div>
      <nav>
        <li><a href="tel:888-874-9120">888.874.9120</a></li>
        <li><a class="button locations-link">Locations</a></li>
      </nav>
      <button type="button" class="navicon tcon tcon-menu--xbutterfly" aria-label="toggle menu">
        <span class="tcon-menu__lines" aria-hidden="true"></span>
        <span class="tcon-visuallyhidden">toggle menu</span>
      </button>
    </div>
    <div class="nav-mobile">
      <div class="nav-item">
        <a href="tel:888-874-9120">888.874.9120</a>
      </div>
      <div class="nav-item">
        <a href="#" class="locations-link locations-link-mobile">Locations</a>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    name:'Header',
    data(){
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue